import { render, staticRenderFns } from "./fccGestaoRecuperacaoArquivos.vue?vue&type=template&id=bebb6aee"
import script from "./fccGestaoRecuperacaoArquivos.vue?vue&type=script&lang=js"
export * from "./fccGestaoRecuperacaoArquivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports